import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { disabled: Boolean }

  connect() {
    if (this.disabledValue) {
      document.addEventListener("turbo:before-visit", this.preventProgress)
      document.addEventListener("turbo:visit", this.preventProgress)
      document.addEventListener("turbo:before-cache", this.preventProgress)
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.preventProgress)
    document.removeEventListener("turbo:visit", this.preventProgress)
    document.removeEventListener("turbo:before-cache", this.preventProgress)
  }

  preventProgress(event) {
    const element = document.querySelector(".turbo-progress-bar")
    if (element) {
      element.remove()
    }
    const styleId = "turbo-progress-bar-style"
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style")
      style.id = styleId
      style.innerHTML = `.turbo-progress-bar { display: none !important; }`
      document.head.appendChild(style)
    }
  }
}
